<template>
  <vx-card title="Beginning Balance">
    <vs-tabs>
      <vs-tab label="Debit Note Claims">
        <div class="tab-text">
          <DebitNoteClaim></DebitNoteClaim>
        </div>
      </vs-tab>
      <vs-tab label="Moving Average Price">
        <div class="tab-text">
          <Map></Map>
        </div>
      </vs-tab>
      <vs-tab label="Item Stock">
        <div class="tab-text">
          <ItemStock></ItemStock>
        </div>
      </vs-tab>
      <vs-tab label="AP">
        <div class="tab-text">
          <Ap></Ap>
        </div>
      </vs-tab>
      <vs-tab label="AR Invoice">
        <ar-invoice />
      </vs-tab>
      <vs-tab label="Credit Note"> <credit-note /></vs-tab>
      <vs-tab label="Customer Deposit"> <customer-deposit /> </vs-tab>
      <vs-tab label="Debit Note Return">
        <DebitNoteReturn />
      </vs-tab>
      <vs-tab label="Advance Invoice">
        <AdvanceInvoice />
      </vs-tab>
      <vs-tab label="CN Temporary">
        <CNTemporary />
      </vs-tab>
      <vs-tab label="Supplier Deposit">
        <SupplierDeposit />
      </vs-tab>
      <vs-tab label="Credit Note Claim Mix">
        <credit-note-claim-manual />
      </vs-tab>
      <vs-tab label="Credit Note Supplier">
        <credit-note-supplier />
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>
<script>
import DebitNoteClaim from "./debit-note-claims/index.vue";
import Map from "./moving-average-price/index.vue";
import ItemStock from "./item-stock/index.vue";
import Ap from "./ap/index.vue";
import ARInvoice from "./ar_invoice/index.vue";
import CustomerDeposit from "./customer_deposit/index.vue";
import CreditNote from "./credit_note/index.vue";
import DebitNoteReturn from "./debit-note-return/index.vue";
import AdvanceInvoice from "./advance-invoice/index.vue";
import CNTemporary from "./cn-temporary/index.vue";
import SupplierDeposit from "./supplier_deposit/index.vue";
import CreditNoteClaimManual from "./credit_note_claim_manual/index.vue";
import CreditNoteSupplier from "./credit_note_supplier/index.vue";
export default {
  components: {
    DebitNoteClaim,
    Map,
    ItemStock,
    Ap,
    "ar-invoice": ARInvoice,
    "customer-deposit": CustomerDeposit,
    "credit-note": CreditNote,
    DebitNoteReturn,
    CNTemporary,
    AdvanceInvoice,
    SupplierDeposit,
    "credit-note-claim-manual": CreditNoteClaimManual,
    "credit-note-supplier": CreditNoteSupplier,
  },
};
</script>

<style>
.con-ul-tabs {
  overflow-x: hidden !important;
  height: 7dvh;
  white-space: nowrap;
}
.con-ul-tabs::-webkit-scrollbar {
  height: 7px;
  opacity: 0;
}

.con-ul-tabs:hover {
  overflow-x: auto !important;
}

.con-ul-tabs::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3); /* darkish scrollbar thumb */
  border-radius: 4px;
}

.con-ul-tabs::-webkit-scrollbar-track {
  background: transparent; /* optional */
}
</style>
